import React, { memo, useCallback, useMemo } from 'react'

import { FiltersSidebar, Icon, Sort2 } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { FILTER_NAME } from 'Pods/SearchPage/Shared/Tracking/constants'
import { useTrackFilterSelect } from 'Pods/SearchPage/Shared/Tracking/FilterTracking'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { setSortBy } from 'Pods/SearchPage/Store/actions/sortBy'
import { SORT_BY } from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import FiltersWrapper from 'Pods/Shared/FiltersWrapper/FiltersWrapper'

import { buildSortingFiltersConfig } from './constants'

const prefixIcon = <Icon notSpaced svgComponent={Sort2} color="dark" size="small" />

function Sorting() {
  const translate = useTranslate()
  const trackFilterSelect = useTrackFilterSelect()
  const sortBy = useSearchPageStore(state => state.sortBy)

  const sortingFiltersConfig = useMemo(
    () => buildSortingFiltersConfig(translate, sortBy),
    [translate, sortBy]
  )

  const sortLabelByValue = useMemo(() => sortingFiltersConfig[0].filters.reduce((acc, filter) => {
    acc[filter.value] = filter.label
    return acc
  }, {}), [sortingFiltersConfig])

  const hasSelectedAnyFilter = useMemo(() => {
    return sortBy !== SORT_BY.BEST_MATCH
  }, [sortBy])

  const placeholder = sortLabelByValue[sortBy] || translate('search_page.filters.sorting.title')

  const handleSortChange = useCallback((_, value) => {
    trackFilterSelect(FILTER_NAME.SORT_BY, value)
    setSortBy(value)
  }, [trackFilterSelect])

  const selectedSort = useMemo(() => {
    return [sortBy]
  }, [sortBy])

  // Figma 590:28155 has no Reset: Best match is one of the options, so picking it resets the sort.
  const content = useMemo(() => (
    <FiltersSidebar
      isCollapsible={false}
      filters={sortingFiltersConfig}
      selectedFilters={selectedSort}
      onFiltersChange={handleSortChange}
      isControlled
      hideLastDivider
      hideShowMore
      baseFormWrapperClassName="filter-wrapper__content"
      useNewCheckboxes
      useRadio
    />
  ), [selectedSort, handleSortChange, sortingFiltersConfig])

  return (
    <div className="sorting">
      <FiltersWrapper
        trailIconSize="small"
        placeholder={placeholder}
        prefixIcon={prefixIcon}
        content={content}
        hasSelectedAnyFilters={hasSelectedAnyFilter}
        positionHorizontal="left"
        closingDropdownClassName="filter-wrapper sorting__select"
        contentClassName="sorting__dropdown-content"
        size="medium"
      />
    </div>
  )
}

export default memo(Sorting)
